var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.type=='InstrumentUltimateTzCheckMeBack')?_c('CheckMeBack',{attrs:{"customer":_vm.customer,"instrument":_vm.instrument}}):(_vm.type=='InstrumentUltimateTzGovernment')?_c('Government',{attrs:{"customer":_vm.customer,"instrument":_vm.instrument}}):_c('SalaryAdvance',{attrs:{"customer":_vm.customer,"instrument":_vm.instrument}})
}
var staticRenderFns = []

export { render, staticRenderFns }